// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.new-bar-link {
  padding: 1em;
}

.new-bar-link a {
  text-decoration: none;
}

.new-bar-form *:not(button) {
  margin: 0 1em;
  padding: 0;
}

.new-bar-form {
  display: flex;
  flex-direction: column;
  gap: 2em;
  width: 100%;
  max-width: 40em;
  margin: 0 auto 0;
  padding: 1em;
  background-color: #fff;
  border-radius: 20px;
}

.new-bar-form-title {
  color: var(--purple-mid);
}

.new-bar-form label {
  color: var(--purple-mid);
  text-align: left;
  margin: auto;
  width: 90%;
}

.new-bar-form input,
.new-bar-form textarea {
  width: 41em;
  margin: .5em auto;
  padding: .5em 1em;
  border: 1px solid #fff;
  border-radius: 5px;
  background-color: #D9D9D9;
}

.new-bar-form textarea {
  height: 10em;
}

.new-bar-error-message {
  color: red !important;
  font-size: smaller;
  float: right;
  margin: 0;
  padding: 0;
}

.new-bar-submit {
  border: none;
  border-radius: 5px;
  padding: .5em 3em;
  margin: 2em auto;
  width: 90%;
  font-size: 1em;
  font-weight: bold;
  color: #fff;
  background-color: var(--purple-drk);
}

.new-bar-submit:focus {
  outline: none;
  box-shadow: 0 0 0 .25rem var(--purple-drk);
}

.new-bar-submit:hover {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/features/user/user.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,YAAY;EACZ,UAAU;AACZ;;AAEA;;EAEE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".new-bar-link {\n  padding: 1em;\n}\n\n.new-bar-link a {\n  text-decoration: none;\n}\n\n.new-bar-form *:not(button) {\n  margin: 0 1em;\n  padding: 0;\n}\n\n.new-bar-form {\n  display: flex;\n  flex-direction: column;\n  gap: 2em;\n  width: 100%;\n  max-width: 40em;\n  margin: 0 auto 0;\n  padding: 1em;\n  background-color: #fff;\n  border-radius: 20px;\n}\n\n.new-bar-form-title {\n  color: var(--purple-mid);\n}\n\n.new-bar-form label {\n  color: var(--purple-mid);\n  text-align: left;\n  margin: auto;\n  width: 90%;\n}\n\n.new-bar-form input,\n.new-bar-form textarea {\n  width: 41em;\n  margin: .5em auto;\n  padding: .5em 1em;\n  border: 1px solid #fff;\n  border-radius: 5px;\n  background-color: #D9D9D9;\n}\n\n.new-bar-form textarea {\n  height: 10em;\n}\n\n.new-bar-error-message {\n  color: red !important;\n  font-size: smaller;\n  float: right;\n  margin: 0;\n  padding: 0;\n}\n\n.new-bar-submit {\n  border: none;\n  border-radius: 5px;\n  padding: .5em 3em;\n  margin: 2em auto;\n  width: 90%;\n  font-size: 1em;\n  font-weight: bold;\n  color: #fff;\n  background-color: var(--purple-drk);\n}\n\n.new-bar-submit:focus {\n  outline: none;\n  box-shadow: 0 0 0 .25rem var(--purple-drk);\n}\n\n.new-bar-submit:hover {\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
